import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';
import scrollBehavior from './router.scrollBehavior.js';
var _7c5964d6 = function _7c5964d6() {
  return interopDefault(import('../pages/monitoring.vue' /* webpackChunkName: "pages/monitoring" */));
};
var _1ce6ac99 = function _1ce6ac99() {
  return interopDefault(import('../pages/redirect_url.vue' /* webpackChunkName: "pages/redirect_url" */));
};
var _0c970347 = function _0c970347() {
  return interopDefault(import('../pages/tools/grid.vue' /* webpackChunkName: "pages/tools/grid" */));
};
var _4714d06e = function _4714d06e() {
  return interopDefault(import('../pages/_market/_language/index.vue' /* webpackChunkName: "pages/_market/_language/index" */));
};
var _3aea4628 = function _3aea4628() {
  return interopDefault(import('../pages/_market/_language/autolog.vue' /* webpackChunkName: "pages/_market/_language/autolog" */));
};
var _ca75be62 = function _ca75be62() {
  return interopDefault(import('../pages/_market/_language/barcodes/index.vue' /* webpackChunkName: "pages/_market/_language/barcodes/index" */));
};
var _a3b2ff0e = function _a3b2ff0e() {
  return interopDefault(import('../pages/_market/_language/cart.vue' /* webpackChunkName: "pages/_market/_language/cart" */));
};
var _64ed31c6 = function _64ed31c6() {
  return interopDefault(import('../pages/_market/_language/help/index.vue' /* webpackChunkName: "pages/_market/_language/help/index" */));
};
var _b3c58a40 = function _b3c58a40() {
  return interopDefault(import('../pages/_market/_language/login.vue' /* webpackChunkName: "pages/_market/_language/login" */));
};
var _68f533ca = function _68f533ca() {
  return interopDefault(import('../pages/_market/_language/lost-password.vue' /* webpackChunkName: "pages/_market/_language/lost-password" */));
};
var _73a22cf2 = function _73a22cf2() {
  return interopDefault(import('../pages/_market/_language/reset-password.vue' /* webpackChunkName: "pages/_market/_language/reset-password" */));
};
var _69e40e31 = function _69e40e31() {
  return interopDefault(import('../pages/_market/_language/signup.vue' /* webpackChunkName: "pages/_market/_language/signup" */));
};
var _0b489bef = function _0b489bef() {
  return interopDefault(import('../pages/_market/_language/sitemap/index.vue' /* webpackChunkName: "pages/_market/_language/sitemap/index" */));
};
var _edcf7538 = function _edcf7538() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue' /* webpackChunkName: "pages/_market/_language/store-locator/index" */));
};
var _44e4df27 = function _44e4df27() {
  return interopDefault(import('../pages/_market/_language/user/index.vue' /* webpackChunkName: "pages/_market/_language/user/index" */));
};
var _348f85cc = function _348f85cc() {
  return interopDefault(import('../pages/_market/_language/gift-card/e-gift-card.vue' /* webpackChunkName: "pages/_market/_language/gift-card/e-gift-card" */));
};
var _d797c56a = function _d797c56a() {
  return interopDefault(import('../pages/_market/_language/help/confirm.vue' /* webpackChunkName: "pages/_market/_language/help/confirm" */));
};
var _278dc5b7 = function _278dc5b7() {
  return interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue' /* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */));
};
var _25e4e088 = function _25e4e088() {
  return interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue' /* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */));
};
var _3aa89dd5 = function _3aa89dd5() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue' /* webpackChunkName: "pages/_market/_language/s/home-by-me" */));
};
var _fba93c7e = function _fba93c7e() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue' /* webpackChunkName: "pages/_market/_language/s/lighting" */));
};
var _26024274 = function _26024274() {
  return interopDefault(import('../pages/_market/_language/s/sustainable-development.vue' /* webpackChunkName: "pages/_market/_language/s/sustainable-development" */));
};
var _3f907a09 = function _3f907a09() {
  return interopDefault(import('../pages/_market/_language/t/confirmation.vue' /* webpackChunkName: "pages/_market/_language/t/confirmation" */));
};
var _24db0a3b = function _24db0a3b() {
  return interopDefault(import('../pages/_market/_language/t/confirmed.vue' /* webpackChunkName: "pages/_market/_language/t/confirmed" */));
};
var _6ef22345 = function _6ef22345() {
  return interopDefault(import('../pages/_market/_language/t/login.vue' /* webpackChunkName: "pages/_market/_language/t/login" */));
};
var _03f21980 = function _03f21980() {
  return interopDefault(import('../pages/_market/_language/t/lost-password.vue' /* webpackChunkName: "pages/_market/_language/t/lost-password" */));
};
var _0fbb6e62 = function _0fbb6e62() {
  return interopDefault(import('../pages/_market/_language/t/payment.vue' /* webpackChunkName: "pages/_market/_language/t/payment" */));
};
var _17867c70 = function _17867c70() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-canceled.vue' /* webpackChunkName: "pages/_market/_language/t/payment-paypal-canceled" */));
};
var _33ef5ab8 = function _33ef5ab8() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue' /* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */));
};
var _1cf9ea2c = function _1cf9ea2c() {
  return interopDefault(import('../pages/_market/_language/t/refused.vue' /* webpackChunkName: "pages/_market/_language/t/refused" */));
};
var _1f9cb5fc = function _1f9cb5fc() {
  return interopDefault(import('../pages/_market/_language/t/shipping.vue' /* webpackChunkName: "pages/_market/_language/t/shipping" */));
};
var _88a79b28 = function _88a79b28() {
  return interopDefault(import('../pages/_market/_language/t/signup.vue' /* webpackChunkName: "pages/_market/_language/t/signup" */));
};
var _6fa232c7 = function _6fa232c7() {
  return interopDefault(import('../pages/_market/_language/t/signup-paypal-express.vue' /* webpackChunkName: "pages/_market/_language/t/signup-paypal-express" */));
};
var _7dbee8de = function _7dbee8de() {
  return interopDefault(import('../pages/_market/_language/t/signup-paypal-express-pending.vue' /* webpackChunkName: "pages/_market/_language/t/signup-paypal-express-pending" */));
};
var _5752147a = function _5752147a() {
  return interopDefault(import('../pages/_market/_language/user/gift-card-download.vue' /* webpackChunkName: "pages/_market/_language/user/gift-card-download" */));
};
var _528c7181 = function _528c7181() {
  return interopDefault(import('../pages/_market/_language/user/gift-cards.vue' /* webpackChunkName: "pages/_market/_language/user/gift-cards" */));
};
var _20a49463 = function _20a49463() {
  return interopDefault(import('../pages/_market/_language/user/orders/index.vue' /* webpackChunkName: "pages/_market/_language/user/orders/index" */));
};
var _cebc7d84 = function _cebc7d84() {
  return interopDefault(import('../pages/_market/_language/user/profile.vue' /* webpackChunkName: "pages/_market/_language/user/profile" */));
};
var _521be141 = function _521be141() {
  return interopDefault(import('../pages/_market/_language/user/profile/index.vue' /* webpackChunkName: "pages/_market/_language/user/profile/index" */));
};
var _1f020891 = function _1f020891() {
  return interopDefault(import('../pages/_market/_language/user/profile/addresses.vue' /* webpackChunkName: "pages/_market/_language/user/profile/addresses" */));
};
var _3af64db8 = function _3af64db8() {
  return interopDefault(import('../pages/_market/_language/user/profile/alerts.vue' /* webpackChunkName: "pages/_market/_language/user/profile/alerts" */));
};
var _2b6de57c = function _2b6de57c() {
  return interopDefault(import('../pages/_market/_language/user/profile/password.vue' /* webpackChunkName: "pages/_market/_language/user/profile/password" */));
};
var _23a4ac00 = function _23a4ac00() {
  return interopDefault(import('../pages/_market/_language/user/wishlist.vue' /* webpackChunkName: "pages/_market/_language/user/wishlist" */));
};
var _9a565e04 = function _9a565e04() {
  return interopDefault(import('../pages/_market/_language/help/merchant/confirm.vue' /* webpackChunkName: "pages/_market/_language/help/merchant/confirm" */));
};
var _f32dfbca = function _f32dfbca() {
  return interopDefault(import('../pages/_market/_language/configurator/product/_model.vue' /* webpackChunkName: "pages/_market/_language/configurator/product/_model" */));
};
var _66d9d792 = function _66d9d792() {
  return interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue' /* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */));
};
var _cfba874e = function _cfba874e() {
  return interopDefault(import('../pages/_market/_language/e/unsubscribe/_slug.vue' /* webpackChunkName: "pages/_market/_language/e/unsubscribe/_slug" */));
};
var _1bce113f = function _1bce113f() {
  return interopDefault(import('../pages/_market/_language/help/contact/_form.vue' /* webpackChunkName: "pages/_market/_language/help/contact/_form" */));
};
var _735ae1ef = function _735ae1ef() {
  return interopDefault(import('../pages/_market/_language/help/faq/_answer.vue' /* webpackChunkName: "pages/_market/_language/help/faq/_answer" */));
};
var _6c74d089 = function _6c74d089() {
  return interopDefault(import('../pages/_market/_language/help/return/_form.vue' /* webpackChunkName: "pages/_market/_language/help/return/_form" */));
};
var _9dfbcb64 = function _9dfbcb64() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference/index.vue' /* webpackChunkName: "pages/_market/_language/user/orders/_reference/index" */));
};
var _10fc369e = function _10fc369e() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference/cancel/index.vue' /* webpackChunkName: "pages/_market/_language/user/orders/_reference/cancel/index" */));
};
var _c3ece9c4 = function _c3ece9c4() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/index.vue' /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/index" */));
};
var _22ab6421 = function _22ab6421() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/messages.vue' /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/messages" */));
};
var _99db1852 = function _99db1852() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/notation.vue' /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/notation" */));
};
var _28708a10 = function _28708a10() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/product/_code.vue' /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/product/_code" */));
};
var _c05787d0 = function _c05787d0() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/_code.vue' /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/_code" */));
};
var _5deffad6 = function _5deffad6() {
  return interopDefault(import('../pages/_market/_language/c/_alias.vue' /* webpackChunkName: "pages/_market/_language/c/_alias" */));
};
var _b7dd3c0a = function _b7dd3c0a() {
  return interopDefault(import('../pages/_market/_language/configurator/_model.vue' /* webpackChunkName: "pages/_market/_language/configurator/_model" */));
};
var _34338e5d = function _34338e5d() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue' /* webpackChunkName: "pages/_market/_language/inspirations/_slug" */));
};
var _aa3f1ee8 = function _aa3f1ee8() {
  return interopDefault(import('../pages/_market/_language/m/_alias.vue' /* webpackChunkName: "pages/_market/_language/m/_alias" */));
};
var _7c153eae = function _7c153eae() {
  return interopDefault(import('../pages/_market/_language/p/_alias.vue' /* webpackChunkName: "pages/_market/_language/p/_alias" */));
};
var _20435dbe = function _20435dbe() {
  return interopDefault(import('../pages/_market/_language/q/_keyword.vue' /* webpackChunkName: "pages/_market/_language/q/_keyword" */));
};
var _cf88a862 = function _cf88a862() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue' /* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */));
};
var _d3e9a946 = function _d3e9a946() {
  return interopDefault(import('../pages/_market/_language/index.vue' /* webpackChunkName: "" */));
};
var _63bd6b49 = function _63bd6b49() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue' /* webpackChunkName: "" */));
};
var _52a6eaad = function _52a6eaad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue' /* webpackChunkName: "" */));
};
var _4b34c87e = function _4b34c87e() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue' /* webpackChunkName: "" */));
};
var _01fc28ae = function _01fc28ae() {
  return interopDefault(import('../pages/_market/_language/gift-card/e-gift-card.vue' /* webpackChunkName: "" */));
};
var _3cb0debb = function _3cb0debb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue' /* webpackChunkName: "" */));
};
var _4aca05f8 = function _4aca05f8() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue' /* webpackChunkName: "" */));
};

// TODO: remove in Nuxt 3
var emptyFn = function emptyFn() {};
var originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyFn;
  var onAbort = arguments.length > 2 ? arguments[2] : undefined;
  return originalPush.call(this, location, onComplete, onAbort);
};
Vue.use(Router);
export var routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior: scrollBehavior,
  routes: [{
    path: "/monitoring",
    component: _7c5964d6,
    name: "monitoring"
  }, {
    path: "/redirect_url",
    component: _1ce6ac99,
    name: "redirect_url"
  }, {
    path: "/tools/grid",
    component: _0c970347,
    name: "tools-grid"
  }, {
    path: "/:market?/:language",
    component: _4714d06e,
    name: "market-language"
  }, {
    path: "/:market?/:language?/autolog",
    component: _3aea4628,
    name: "market-language-autolog"
  }, {
    path: "/:market?/:language?/barcodes",
    component: _ca75be62,
    name: "market-language-barcodes"
  }, {
    path: "/:market?/:language?/cart",
    component: _a3b2ff0e,
    name: "market-language-cart"
  }, {
    path: "/:market?/:language?/help",
    component: _64ed31c6,
    name: "market-language-help"
  }, {
    path: "/:market?/:language?/login",
    component: _b3c58a40,
    name: "market-language-login"
  }, {
    path: "/:market?/:language?/lost-password",
    component: _68f533ca,
    name: "market-language-lost-password"
  }, {
    path: "/:market?/:language?/reset-password",
    component: _73a22cf2,
    name: "market-language-reset-password"
  }, {
    path: "/:market?/:language?/signup",
    component: _69e40e31,
    name: "market-language-signup"
  }, {
    path: "/:market?/:language?/sitemap",
    component: _0b489bef,
    name: "market-language-sitemap"
  }, {
    path: "/:market?/:language?/store-locator",
    component: _edcf7538,
    name: "market-language-store-locator"
  }, {
    path: "/:market?/:language?/user",
    component: _44e4df27,
    name: "market-language-user"
  }, {
    path: "/:market?/:language?/gift-card/e-gift-card",
    component: _348f85cc,
    name: "market-language-gift-card-e-gift-card"
  }, {
    path: "/:market?/:language?/help/confirm",
    component: _d797c56a,
    name: "market-language-help-confirm"
  }, {
    path: "/:market?/:language?/help/deliveryConfirm",
    component: _278dc5b7,
    name: "market-language-help-deliveryConfirm"
  }, {
    path: "/:market?/:language?/s/catalogue-luminaires",
    component: _25e4e088,
    name: "market-language-s-catalogue-luminaires"
  }, {
    path: "/:market?/:language?/s/home-by-me",
    component: _3aa89dd5,
    name: "market-language-s-home-by-me"
  }, {
    path: "/:market?/:language?/s/lighting",
    component: _fba93c7e,
    name: "market-language-s-lighting"
  }, {
    path: "/:market?/:language?/s/sustainable-development",
    component: _26024274,
    name: "market-language-s-sustainable-development"
  }, {
    path: "/:market?/:language?/t/confirmation",
    component: _3f907a09,
    name: "market-language-t-confirmation"
  }, {
    path: "/:market?/:language?/t/confirmed",
    component: _24db0a3b,
    name: "market-language-t-confirmed"
  }, {
    path: "/:market?/:language?/t/login",
    component: _6ef22345,
    name: "market-language-t-login"
  }, {
    path: "/:market?/:language?/t/lost-password",
    component: _03f21980,
    name: "market-language-t-lost-password"
  }, {
    path: "/:market?/:language?/t/payment",
    component: _0fbb6e62,
    name: "market-language-t-payment"
  }, {
    path: "/:market?/:language?/t/payment-paypal-canceled",
    component: _17867c70,
    name: "market-language-t-payment-paypal-canceled"
  }, {
    path: "/:market?/:language?/t/payment-paypal-pending",
    component: _33ef5ab8,
    name: "market-language-t-payment-paypal-pending"
  }, {
    path: "/:market?/:language?/t/refused",
    component: _1cf9ea2c,
    name: "market-language-t-refused"
  }, {
    path: "/:market?/:language?/t/shipping",
    component: _1f9cb5fc,
    name: "market-language-t-shipping"
  }, {
    path: "/:market?/:language?/t/signup",
    component: _88a79b28,
    name: "market-language-t-signup"
  }, {
    path: "/:market?/:language?/t/signup-paypal-express",
    component: _6fa232c7,
    name: "market-language-t-signup-paypal-express"
  }, {
    path: "/:market?/:language?/t/signup-paypal-express-pending",
    component: _7dbee8de,
    name: "market-language-t-signup-paypal-express-pending"
  }, {
    path: "/:market?/:language?/user/gift-card-download",
    component: _5752147a,
    name: "market-language-user-gift-card-download"
  }, {
    path: "/:market?/:language?/user/gift-cards",
    component: _528c7181,
    name: "market-language-user-gift-cards"
  }, {
    path: "/:market?/:language?/user/orders",
    component: _20a49463,
    name: "market-language-user-orders"
  }, {
    path: "/:market?/:language?/user/profile",
    component: _cebc7d84,
    children: [{
      path: "",
      component: _521be141,
      name: "market-language-user-profile"
    }, {
      path: "addresses",
      component: _1f020891,
      name: "market-language-user-profile-addresses"
    }, {
      path: "alerts",
      component: _3af64db8,
      name: "market-language-user-profile-alerts"
    }, {
      path: "password",
      component: _2b6de57c,
      name: "market-language-user-profile-password"
    }]
  }, {
    path: "/:market?/:language?/user/wishlist",
    component: _23a4ac00,
    name: "market-language-user-wishlist"
  }, {
    path: "/:market?/:language?/help/merchant/confirm",
    component: _9a565e04,
    name: "market-language-help-merchant-confirm"
  }, {
    path: "/:market?/:language?/configurator/product/:model?",
    component: _f32dfbca,
    name: "market-language-configurator-product-model"
  }, {
    path: "/:market?/:language?/e/magazine/:slug?",
    component: _66d9d792,
    name: "market-language-e-magazine-slug"
  }, {
    path: "/:market?/:language?/e/unsubscribe/:slug?",
    component: _cfba874e,
    name: "market-language-e-unsubscribe-slug"
  }, {
    path: "/:market?/:language?/help/contact/:form?",
    component: _1bce113f,
    name: "market-language-help-contact-form"
  }, {
    path: "/:market?/:language?/help/faq/:answer?",
    component: _735ae1ef,
    name: "market-language-help-faq-answer"
  }, {
    path: "/:market?/:language?/help/return/:form?",
    component: _6c74d089,
    name: "market-language-help-return-form"
  }, {
    path: "/:market?/:language?/user/orders/:reference",
    component: _9dfbcb64,
    name: "market-language-user-orders-reference"
  }, {
    path: "/:market?/:language?/user/orders/:reference/cancel",
    component: _10fc369e,
    name: "market-language-user-orders-reference-cancel"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact",
    component: _c3ece9c4,
    name: "market-language-help-merchant-order-reference-contact"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/messages",
    component: _22ab6421,
    name: "market-language-help-merchant-order-reference-messages"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/notation",
    component: _99db1852,
    name: "market-language-help-merchant-order-reference-notation"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact/product/:code?",
    component: _28708a10,
    name: "market-language-help-merchant-order-reference-contact-product-code"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact/:code",
    component: _c05787d0,
    name: "market-language-help-merchant-order-reference-contact-code"
  }, {
    path: "/:market?/:language?/c/:alias?",
    component: _5deffad6,
    name: "market-language-c-alias"
  }, {
    path: "/:market?/:language?/configurator/:model?",
    component: _b7dd3c0a,
    name: "market-language-configurator-model"
  }, {
    path: "/:market?/:language?/inspirations/:slug?",
    component: _34338e5d,
    name: "market-language-inspirations-slug"
  }, {
    path: "/:market?/:language?/m/:alias?",
    component: _aa3f1ee8,
    name: "market-language-m-alias"
  }, {
    path: "/:market?/:language?/p/:alias?",
    component: _7c153eae,
    name: "market-language-p-alias"
  }, {
    path: "/:market?/:language?/q/:keyword?",
    component: _20435dbe,
    name: "market-language-q-keyword"
  }, {
    path: "/:market?/:language?/e/:alias?/:slug?",
    component: _cf88a862,
    name: "market-language-e-alias-slug"
  }, {
    path: "/",
    component: _d3e9a946,
    name: "market-language-home-fr"
  }, {
    path: "/:market/:language/inspirations*",
    component: _63bd6b49,
    name: "market-language-inspirations-fr"
  }, {
    path: "/:market/:language/inspirationen*",
    component: _63bd6b49,
    name: "market-language-inspirations-de"
  }, {
    path: "/:market/:language/ispirazione*",
    component: _63bd6b49,
    name: "market-language-inspirations-it"
  }, {
    path: "/:market/:language/inspiration*",
    component: _63bd6b49,
    name: "market-language-inspirations-en"
  }, {
    path: "/:market/:language/inspiration*",
    component: _63bd6b49,
    name: "market-language-inspirations-pt"
  }, {
    path: "/:market/:language/inspiracion*",
    component: _63bd6b49,
    name: "market-language-inspirations-es"
  }, {
    path: "/:market/:language/s/inspiratie*",
    component: _63bd6b49,
    name: "market-language-inspirations-nl"
  }, {
    path: "/:market/:language/s/luminaires*",
    component: _52a6eaad,
    name: "market-language-lighting-fr"
  }, {
    path: "/:market/:language/s/leuchten*",
    component: _52a6eaad,
    name: "market-language-lighting-de"
  }, {
    path: "/:market/:language/s/illuminazioni*",
    component: _52a6eaad,
    name: "market-language-lighting-it"
  }, {
    path: "/:market/:language/s/lighting*",
    component: _52a6eaad,
    name: "market-language-lighting-en"
  }, {
    path: "/:market/:language/s/lighting*",
    component: _52a6eaad,
    name: "market-language-lighting-pt"
  }, {
    path: "/:market/:language/s/lamparas*",
    component: _52a6eaad,
    name: "market-language-lighting-es"
  }, {
    path: "/:market/:language/s/verlichting*",
    component: _52a6eaad,
    name: "market-language-lighting-nl"
  }, {
    path: "/:market/:language/s/atelier-deco*",
    component: _4b34c87e,
    name: "market-language-home-by-me-fr"
  }, {
    path: "/:market/:language/s/atelier-arredo*",
    component: _4b34c87e,
    name: "market-language-home-by-me-it"
  }, {
    path: "/:market/:language/s/taller-de-decoracion*",
    component: _4b34c87e,
    name: "market-language-home-by-me-es"
  }, {
    path: "/:market/:language/s/dekowerkstatt*",
    component: _4b34c87e,
    name: "market-language-home-by-me-de"
  }, {
    path: "/:market/:language/s/decor-workshop*",
    component: _4b34c87e,
    name: "market-language-home-by-me-en"
  }, {
    path: "/:market/:language/gc/e-carte-cadeau-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-fr-FR"
  }, {
    path: "/:market/:language/gc/digitale-cadeaukaart-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-nl-BE"
  }, {
    path: "/:market/:language/gc/e-carte-cadeau-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-fr-BE"
  }, {
    path: "/:market/:language/gc/geschenkkarte-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-de-DE"
  }, {
    path: "/:market/:language/gc/tarjeta-regalo-electronica-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-es-ES"
  }, {
    path: "/:market/:language/gc/carta-regalo-digitale-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-it-IT"
  }, {
    path: "/:market/:language/gc/e-carte-cadeau-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-fr-LU"
  }, {
    path: "/:market/:language/gc/digitale-cadeaukaart-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-nl-NL"
  }, {
    path: "/:market/:language/gc/cartao-presente-eletronico-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-pt-PT"
  }, {
    path: "/:market/:language/gc/geschenk-karte-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-de-CH"
  }, {
    path: "/:market/:language/gc/carta-regalo-digitale-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-it-CH"
  }, {
    path: "/:market/:language/gc/e-carte-cadeau-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-fr-CH"
  }, {
    path: "/:market/:language/gc/online-gift-card-maisons-du-monde*",
    component: _01fc28ae,
    name: "market-language-e-gift-card-en-GB"
  }, {
    path: "/:market/:language/:alias/:slug",
    component: _3cb0debb,
    name: "market-language-editorial"
  }, {
    path: "/:market/:language/magasins/",
    component: _4aca05f8,
    name: "store-locator"
  }],
  fallback: false
};
export function createRouter() {
  var router = new Router(routerOptions);
  var resolve = router.resolve.bind(router);

  // encodeURI(decodeURI()) ~> support both encoded and non-encoded urls
  router.resolve = function (to, current, append) {
    if (typeof to === 'string') {
      to = encodeURI(decodeURI(to));
    }
    return resolve(to, current, append);
  };
  return router;
}